var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 67,
    viewBox: "0 0 76 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 508",
    d: "M45.2966 50.8456L52.2287 43.9135M27.7839 26.4009V41.7245L45.2966 58.1426L59.8905 43.9135L42.7427 26.4009H27.7839Z",
    stroke: "#7646D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624664",
    x: 1.05566,
    y: 1.13184,
    width: 73.8882,
    height: 64.4022,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624673",
    x: 6.6228,
    y: 8.15845,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624674",
    x: 11.7307,
    y: 8.15845,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624675",
    x: 16.8386,
    y: 8.15845,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624676",
    x: 57.7014,
    y: 8.15845,
    width: 11.6751,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624666",
    x: 1.05566,
    y: 15.7257,
    width: 73.8882,
    height: 49.8083,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 131",
    cx: 36.9052,
    cy: 35.522,
    r: 3.01332,
    stroke: "#7646D7",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.8986dc734270af061a28d5883e317a7e.svg";
export { ForwardRef as ReactComponent };